module.exports = __webpack_public_path__ + "static/media/1009528.fb9c0161.png";